import { render, staticRenderFns } from "./childDetailsModal.vue?vue&type=template&id=2208dd70&"
import script from "./childDetailsModal.vue?vue&type=script&lang=js&"
export * from "./childDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./childDetailsModal.vue?vue&type=style&index=0&id=2208dd70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports